import { Component, OnInit, ViewChild, AfterViewInit, NgZone } from '@angular/core';
import { LanguageService } from '../providers/lang.service';
import { Location } from '@angular/common';
import { CartitemsService } from '../providers/cartitems.service';
import { CustomStorage } from '../providers/Custom-storage.service';
import { Input } from '@angular/core';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import { FormsModule, FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { NgForm } from '@angular/forms';
import { Constant } from '../Constant';
import { environment } from '../../environments/environment';
import { RestApiServices } from '../providers/rest.service';
import { Router, NavigationStart } from '@angular/router';
import { CustomCookieService } from "../providers/mycookie.service";
import { Totalamount } from '../providers/list-of-customers';
import { LoaderComponent } from '../loader/loader.component'
import { EventEmitter } from '@angular/core';
import { Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Directive, ElementRef } from '@angular/core';
import { element } from 'protractor';
import { retry } from 'rxjs/operators/retry';
import { DecimalMask } from "../providers//decimal-mask.directive";
import { CurrencyMaskModule } from "ng2-currency-mask";
import { CurrencyPipe } from '@angular/common';
import { SoapService } from './soap.service';
import { Http } from '@angular/http';
import { setRootDomAdapter } from '@angular/platform-browser/src/dom/dom_adapter';

// import { error } from 'selenium-webdriver';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.css'],
  providers: [SoapService, CurrencyPipe]
})
export class CheckoutComponent implements OnInit, AfterViewInit {
  // @Output() orderNumber: EventEmitter<any> = new EventEmitter();
  // @Output() orderDate: EventEmitter<any> = new EventEmitter();
  private imageUrl: string = environment.imageUrl;
  // private imageUrl = "http://120.138.9.165:8810/CDIServices/";
  dotCount = false
  @ViewChild(SignaturePad) signaturePad: SignaturePad;
  @ViewChild('ngForm') signupForm: NgForm;
  companyControl = new FormControl('', [Validators.required]);
  Amount: string = "";
  show = false;
  IsHidden = true;
  private signaturePadOptions: Object = { // passed through to szimek/signature_pad constructor
    'minWidth': 1,
    'canvasWidth': 500,
    'canvasHeight': 300,
  };

  user = {
    shipping: '',
    tax: '',
    amount: ''
  };
  refId = 0;
  transId = 0;
  formattedAmount: string = '0';
  value: any;
  isNameValid = false;
  ermsg: string
  displaymessage: boolean = false;
  itemsmessage: boolean = false;
  wasClicked: boolean = false
  cardnumDialog: boolean = false;
  monthDialog: boolean = false;
  yearDialog: boolean = false;
  cardcodeDialog: boolean = false;  
  poMatch: boolean;
  cardnumber: number;
  expirydate: number;
  cardcode: number;
  onlinealert: boolean = false;
  InvoiceValCheck: boolean = false;
  checkamount: boolean = false;
  successMessage; string;
  errorMessage:string = '';
  checkoutDialog: boolean = false;
  errorDialog: boolean = false;
  greatermessage: boolean = false;
  userName: string
  myDate = new Date();
  order_number;
  remainamt;
  timeStamp = new Date().getTime().toString();
  poNumber: string = null;
  totalorderamt1: number;
  totalorderamt: number;
  online_payment = this.totalorderamt;
  freeItems: number;
  selectedMonth: any =0;
  selectedYear: any =0;
  //online_amount: number = 0;
  selectedCalendarDate = new Date();
  dateWanted: string = null;
  online_amount: any = 0; selectedvalue: string = ""; lbl_selected: string = ""; actual_online_amount: any = 0;
  ordersummary: string = ""; sub_toal: string = ""; shipping_handling: string = ""; clear: string = "";
  tax_amount: string = ""; order_total: string = ""; order_submit: string = ""; payment_method: string = "";
  order_review: string = ""; order_complete: string = ""; order_terms: string = "";
  cash: string = ""; check: string = ""; invoice: string = ""; amount: string = ""; credit_limit: String = "";
  addpayment_method: string = ""; availablecr: string = ""; shippinginfo: string = "";
  billinginfo: string = ""; item_number: string = ""; quantity: string = ""; items: string = "";
  cartItems = []; primary: string = ""; checkout: string = ""; addsignature: string = "";
  city_tax: string = ""; state_tax: string = ""; valid_name: string = ""; signee_name: string = "";
  amount_check: string = ""; po_required: string = ""; item_not_exist: string = ""; amount_check_more: string = ""
  invalid_pymt_mthd: string = ""; add_sign: string = ""; online_txt: string = ""; invoice_txt: string = "";
  totalItems: number; add_payment: string = ""; po_number: string = ""; name_text: string = ""; order_msg1: string = "";
  order_msg2: string = ""; lbl_ok: string = ""; lbl_uom: string = ""; lbl_qty: string = ""; 
  lbl_pack: string = "Pack Size"; lbl_pallet_quantity: string = "Pallet Quantity"; lbl_free_boxes: string = "Free Quantity";
  customerdetailsData: any; lbl_yes: string = ""; lbl_no: string = ""; lbl_insuff: string = "";
  checkoutdata = []; lbl_onlineexceed: string = ""; lbl_less: string = ""; lbl_remain: string = "";
  usrname: string = ""; pdfnot_avail: string = ""; lbl_noitem: string = ""; lbl_openpdf: string = "";
  isName = false; lbl_lesspay: string = "";
  txt_cardnumber: string = ""; txt_expirydate: string = ""; txt_cardcode: string = "";
  lbl_cardnumber: string = "";lbl_month: string = "";lbl_year: string = "";lbl_cardcode: string = ""; 
  isPonumber = false
  submitted = false;
  match = true;
  checkoutdetails: Object;
  error_message = "";
  invoicevalue: number;
  shippingTax = 0;
  signatureFinal: any = '';
  selected_ship_num: string = 'PRIMARY';
  invoiceamount = "";
  sequenceNo: number;
  invoice_amount: any = 0;
  //invoice_amount: number = 0;
  selectedShippingAddress: any;
  selectedAddress: any;
  isRepeatOrder: boolean = false;
  output;

  //invoiceremaingamount: boolean = false;
  repeatOrderData: any;
  dateWantedDialog: boolean = false;
  signDialog: boolean = false;
  poDialog: boolean = false;
  nameDialog: boolean = false;
  nameDialog1: boolean = false;
  paymentsuccessDialog: boolean = false;
  paymentfailDialog: boolean = false;
  itemsDialog: boolean = false;
  showloading: boolean = true;
  showDialog: boolean = false;
  PDFDialog: boolean = false;
  amountDialog: boolean = false;
  lessamountDialog: boolean = false;
  noPdfavl = false;
  remainvalue = false;
  ipaddr:any;
  isInvoiceSelected = true;
  miliseconds:any;
  years:any = [];
  constructor(private langService: LanguageService, private currencyPipe: CurrencyPipe,
    public el: ElementRef, private zone: NgZone, private soapService: SoapService,
    private cookieService: CustomCookieService, private http: Http,
    public router: Router, private restApi: RestApiServices,
    private location: Location, private localCart: CartitemsService,
    private localStorage: CustomStorage, private route: ActivatedRoute) {
      this.http.get('https://ipapi.co/json/').subscribe(res => {
       // console.log(JSON.stringify(res.json(), null, 2));
         this.ipaddr = res.json();
      });
    // console.log(this.online_amount);
    //  console.log(this.invoice_amount);
    // this.invoice_amount = this.totalorderamt1 - this.online_amount\
    // this.getsoapdata();

    // if(this.location.reload();){
    //   alert("i am reloaded")
    // }
    // this.reloadPage()
    //   this.el.nativeElement.onkeypress = (event) => {
    //     if (event.which >= 48 && event.which <= 57) {  
    //       // to allow numbers  
    //       return true;  
    //   //  } else if (event.which >= 96 && event.which <= 105) {  
    //   //      // to allow numpad number  
    //   //      return true;  
    //    } else if ([8, 0, 127].indexOf(event.which) > -1) {  
    //        // to allow backspace, enter, escape, arrows  
    //        return true;  
    //    } 
    //    else {  
    //       event.preventDefault();  
    //       // to stop others  
    //       return false;  
    //   }  

    // };
    // this.el.nativeElement.onkeypress = (event) => {
    // if (event.which >= 48 && event.which <= 57) {  
    // to allow numbers  
    // return true;  
    //  } else if (event.which >= 96 && event.which <= 105) {  
    //      // to allow numpad number  
    //      return true;  
    //  } else if ([8, 0, 127,46].indexOf(event.which) > -1) {  
    // to allow backspace, enter, escape, arrows  
    //  return true;  
    //  } 
    //  else {  
    // event.preventDefault();  
    // to stop others  
    // return false;  
    // }  

  };
  // }

  ngDoCheck() {
    // console.log(this.Amount);
    if (this.Amount) {
      this.Amount = this.Amount.replace(/[A-Za-z]/g, '');
      if (this.Amount.indexOf('.') !== -1) {
        var arrayVals = this.Amount.split('.');
        this.Amount = arrayVals[0] + "." + arrayVals[1].slice(0, 2);
      }
    }
  }
  ngAfterViewInit() {
    // this.signaturePad is now 
    if (this.signaturePad) {
      this.signaturePad.set('minWidth', 2); // set szimek/signature_pad options at runtime
      this.signaturePad.clear(); // invoke functions from szimek/signature_pad API}

    }
  }
  //   reloadPage() { // click handler or similar
  //     this.zone.runOutsideAngular(()product => {
  //         if(location.reload()){
  //           alert("hi")
  //         }
  //     });
  // }


  getsoapdata() {
    console.log("enteredsaopmethod")
    this.soapService.post('https://api.bcfiscal.com/t/Service.svc', 'GetToken', { taxId: "11122211122", terminalNumber: "POS03", password: "7AA96", computerName: "Test3" })
      .then(result => {
        console.log("sdfsdf" + result);
      }).catch(error => {

      });
  }
  drawComplete() {
    // will be notified of szimek/signature_pad's onEnd event
    this.signatureFinal = this.signaturePad.toDataURL().split(',')[1];
  }
  clearSignature() {
    this.signatureFinal = '';
    this.signaturePad.clear();
  }
  drawStart() {
    // will be notified of signature_pad's onBegin event
  }
  ngOnInit() {
    var date = new Date();
    var year = date.getFullYear();

    for (var i = year; i < year + 5; i++) {
      this.years.push(i);   
    }

    LoaderComponent.loadingV.next(true);

    this.langService.getJson().subscribe(data => {
      this.setLabels();
      this.route.paramMap.map(params => params)
        .subscribe(params => {
          let isRepeatOrder = <any>params.get('repeatOrder') || false;
          let orderNo = <any>params.get('orderNo') || false;
          this.isRepeatOrder = isRepeatOrder;
          this.showloading = false;
          LoaderComponent.loadingV.next(false);
          this.init(orderNo);

        });

    });
    console.log(this);
    // this.getsoapdata();
  }
  poCheck(e) {
    let str = e.target.value;

    if (str.match(/([a-zA-Z]+\-[0-9]+)/)) {
      this.poMatch = true;
      this.poNumber = str;
      // if(this.customerdetailsData.po_required == true){
      // this.wasClicked = true;
      // }
    }
    else {

      // if(this.customerdetailsData.po_required == true){
      // this.wasClicked = true;
      // this.wasClicked=false
      this.poMatch = false;
      // }
    }
  }

  init(orderNo) {

    // this.langService.getJson().subscribe(data => {
    //   this.setLabels();

    this.localStorage.getItem(Constant.KEY_CUSTOMER).subscribe(result => {
      this.customerdetailsData = result.response.data;
      this.wasClicked = this.customerdetailsData.po_required;
      if (this.customerdetailsData.shipping_address.length > 0) {
        this.selectedShippingAddress = this.customerdetailsData.shipping_address[0]
      }
      this.showloading = false;
      LoaderComponent.loadingV.next(false);
    });

    // });

    if (this.isRepeatOrder) {
      this.restApi.getordereditems(orderNo).subscribe(data => {
        this.cartItems = data;
        this.totalItems = this.cartItems.length
        this.calculateShippingTax();
        //this.authorizeNet();
      });
      // this.repeatOrderData = this.localCart.repeatOrderData;

    } else {
      this.localCart.cartList.subscribe(res => {
        console.log(res);
        this.cartItems = res;
        // console.log("tsstdata"+JSON.stringify(this.cartItems))
        this.totalItems = this.cartItems.length
        this.calculateShippingTax();
        //this.authorizeNet();
        //  this.testdata();
      });

      this.localCart.loadCartItems();
      //this.authorizeNet();

    }

  }
  pusheditems = [];
  testdata() {

    this.cartItems.forEach(i => {
      this.pusheditems.push(
        {
          "itemId": i.item_number,
          "name": i.description,
          "description": i.description,
          "quantity": i.quantity,
          "unitPrice": i.unit_price,
        });
    });

    console.log(this.pusheditems)
  }
  updateAmount(e) {
  }
  changeIn(val) {
    this.onlinealert = true;
    let count = 0;
    // if (!val)
    //   return false;
    if (val == undefined){
      val = 0;
      this.invoice_amount = this.totalorderamt1 - val;
      this.invoice_amount = Math.round((this.totalorderamt1 - val) * 100) / 100;
      console.log("invoice amount"+this.invoice_amount)
     }
    let x = val.toString()
    for (let i = 0; i < x.length; i++) {
      if (val == "." || val.length == 0) {
        // break;
        val = 0;
      }
      if (x[i] == '.')
        count++

      if (count == 2) {
        break;
      }

    }

    if (count == 2)
      this.InvoiceValCheck = true
    else {
      this.InvoiceValCheck = false
      // this.invoiceremaingamount=true;
      val = val.replace(/,/g, '')
      this.invoice_amount = this.totalorderamt1 - val;
      this.invoice_amount = Math.round((this.totalorderamt1 - val) * 100) / 100;
      if (this.invoice_amount < 0) {
        this.invoice_amount = 0;
      }
      //this.invoice_amount =  Math.round((this.totalorderamt1 - val) * 100) / 100;

    }

  }
  changeOn(val) {
    let count = 0;
    // if (!val)
    //   return false;
    if (val == undefined){
      console.log("testvalue "+val)
      val = 0;
      this.online_amount = this.totalorderamt1 - val;
      this.online_amount = Math.round((this.totalorderamt1 - val) * 100) / 100;
      console.log("online_amount"+this.online_amount)
     }
    let x = val.toString()
    for (let i = 0; i < x.length; i++) {
      if (val == "." || val.length == 0) {
        // break;
        val = 0;
      }
      if (x[i] == '.')
        count++

      if (count == 2) {
        break;
      }

    }

    if (count == 2)
      this.InvoiceValCheck = true
    else {
      this.InvoiceValCheck = false
      // this.displaymessage = false;
      val = val.replace(/,/g, '')
      this.online_amount = this.totalorderamt1 - val;
      this.online_amount = Math.round((this.totalorderamt1 - val) * 100) / 100;
      if (this.online_amount < 0) {
        this.online_amount = 0;
      }

    }

  }

  doSomething() {

    this.remainvalue = true;
    setTimeout(function () {
      this.remainvalue = false;
    }.bind(this), 3000);
  }

  // public itemsequence : number;
  // sequence(){
  //   for (let i = 0; i <this.cartItems.length; i++)
  //    {
  //     //this.itemsequence += 1;
  //   this.itemsequence=this.cartItems[i];
  //    }

  // }
  nameCheckValid() {
    // var pattern = '^\S[a-zA-Z ]{2,30}$'
    var regex = new RegExp('[a-zA-Z]{2,30}$');
    return regex.test(this.userName)


  }

  onSubmit(form: NgForm) {
    // let totalgivenamount=parseFloat(this.online_amount) +parseFloat(this.invoice_amount);
    let totalgivenamount = +this.online_amount + +this.invoice_amount;
    console.log(totalgivenamount)
    // totalgivenamount =  Math.round((totalgivenamount) * 100) / 100;
    console.log("jegjf" + totalgivenamount);
    
    if (!this.userName) {
      //this.isName = true
      this.nameDialog = !this.nameDialog;
      return true;
    }
    else if (!this.nameCheckValid()) {
      // this.isNameValid = true;
      this.nameDialog1 = !this.nameDialog1;
      return true;
    }

    // if (!this.dateWanted){
    //   this.dateWantedDialog = !this.dateWantedDialog;
    //   return true;
    // }
    // else if (!this.poNumber && this.customerdetailsData.po_required == true) {
    //   //this.poMatch = true
    //   this.poDialog = !this.poDialog;
    //   return true;
    // }
    else if (!this.online_amount && this.invoice_amount == 0 || !this.invoice_amount && this.online_amount == 0 || !this.online_amount && !this.invoice_amount) {
      this.amountDialog = !this.amountDialog;
      return true;
    }

    else if (totalgivenamount < this.totalorderamt1) {
      //this.displaymessage = true;
      this.lessamountDialog = !this.lessamountDialog;
      return true;

    }
    else if (this.cartItems.length == 0) {
      //this.itemsmessage = true;
      this.itemsDialog = !this.itemsDialog;
      return true;
    }
    else if (this.online_amount > 0 && !this.cardnumber && !this.isInvoiceSelected) {
      //alert("please enter cardnumber")
     // alert(this.lbl_cardnumber);
     // return true;
      this.cardnumDialog = !this.cardnumDialog;
      return true;
    }
    else if (this.online_amount > 0 && !this.selectedMonth && !this.isInvoiceSelected) {
      // alert(this.lbl_month);
      // return true;
      this.monthDialog = !this.monthDialog;
      return true;
    }
    else if (this.online_amount > 0 && !this.selectedYear && !this.isInvoiceSelected) {
      // alert(this.lbl_year);
      // return true;
      this.yearDialog = !this.yearDialog;
      return true;
    }
    else if (this.online_amount > 0 && !this.cardcode && !this.isInvoiceSelected) {
      // alert(this.lbl_cardcode);
      // return true;
      this.cardcodeDialog = !this.cardcodeDialog;
      return true;
    }
    else if (this.totalorderamt1 > this.customerdetailsData.available_credit) {
      this.showDialog = !this.showDialog;
      return true;
    }
    
    else if (!this.signatureFinal || this.signatureFinal == '') {
      this.signDialog = true;
      this.IsHidden = true;
      return true;
    }


    else {
      this.orderConfirm();
      // this.proceed();
    }
  }
  proceed() {
    this.showDialog = false;
    //  if(this.poNumber!=null && this.poNumber=='' || this.customerdetailsData.po_required||this.wasClicked){
    let new_date = ("00" + (this.myDate.getMonth() + 1)).slice(-2) + "/" +
      ("00" + this.myDate.getDate()).slice(-2) + "/" +
      ("00" + this.myDate.getFullYear()).slice(-2) + " " +
      ("00" + this.myDate.getHours()).slice(-2) + ":" +
      ("00" + this.myDate.getMinutes()).slice(-2)
    //   alert(
    //     ("00" + (this.d.getMonth() + 1)).slice(-2) + "/" + 
    //     ("00" + this.d.getDate()).slice(-2) + "/" + 
    //     this.d.getFullYear() + " " + 
    //     ("00" + this.d.getHours()).slice(-2) + ":" + 
    //     ("00" + this.d.getMinutes()).slice(-2)
    // );
    // let amt = this.invoice_amount + this.online_amount// + ""+ this.online_amount);

    this.submitted = true;
    var checkout_data = {};
    var checoutCust = {};

    var ttPayment = [];
    var ttCheckoutCustomer = [];
    var ttCheckoutProducts = [];
    // this.invoicevalue = this.signupForm.value.userData.inovice;
    //   this.router.navigate(['/dashboard/orders']);
    var requestBody = {};
    var request = {};
    request['name'] = this.userName;
    request['date_time'] = new_date;
    request['username'] = this.cookieService.getCookieData(Constant.KEY_USERNAME),//Get user name from cookie
      request['available_credit'] = this.customerdetailsData.available_credit;
    request['digital_sign'] = this.signatureFinal;
    request['net_payment_amount'] = this.totalorderamt,
      request['longitude'] = "",
      request['latitude'] = "",

      request['checkout_data'] = checkout_data;
    checkout_data['ttCheckoutCustomer'] = ttCheckoutCustomer;
    checoutCust['temp_number'] = "TMP-NUMBER",
      checoutCust['cust_number'] = (this.cookieService.getCookieData(Constant.KEY_USERNAME).toUpperCase()),
      checoutCust['cust_name'] = (this.cookieService.getCookieData(Constant.KEY_USERNAME).toUpperCase())
    if (this.totalorderamt1 > this.customerdetailsData.available_credit == true) {
      checoutCust['order_on_hold'] = "H"
    }
    else {
      checoutCust['order_on_hold'] = ""
    }
    // checoutCust['order_on_hold'] =  this.totalorderamt1 < this.customerdetailsData.available_credit  = "false" ? "H" : "")
    // for (let item of this.customerdetailsData.shipping_address) {

    checoutCust['shippingAdL1'] = this.selectedShippingAddress.addressL1,
      checoutCust['shippingAdL2'] = this.selectedShippingAddress.addressL2,
      checoutCust['shippingAdL3'] = this.selectedShippingAddress.addressL3,
      checoutCust['ship_to_no'] = this.selectedShippingAddress.ship_number
    // }
    // }
    checoutCust['payment_term'] = this.customerdetailsData.payment_term,
      checoutCust['regular_salesman'] = false,

      // if (this.customerdetailsData.po_required == true) {
      checoutCust['po_number'] = this.poNumber;
      let today = new Date();
      today.setDate(today.getDate() + 2);
      this.onDateChange(today);
      checoutCust['date_wanted'] = this.dateWanted;
    ttCheckoutCustomer.push(checoutCust);
    checoutCust['ttCheckoutProducts'] = ttCheckoutProducts;
    let index = 1;
    for (let item of this.cartItems) {
      let checoutproducts = {};
      checoutproducts['temp_number'] = "TMP-NUMBER",
        checoutproducts['item_sequence'] = index;
      checoutproducts['item_number'] = item.item_number,
        checoutproducts['item_description'] = item.description,
        checoutproducts['quantity'] = item.quantity,
        checoutproducts['unit_price'] = item.unit_price - this.getItemDiscountedPrice(item),
        checoutproducts['item_total_price'] = this.getSubTotalItemPrice(item);
        checoutproducts['item_color'] = item.item_color,
        checoutproducts['item_size'] = item.item_size,
        index++;
        console.log(this.getItemDiscountedPrice(item));
        console.log(this.getSubTotalItemPrice(item));
      ttCheckoutProducts.push(checoutproducts);
      console.log(ttCheckoutProducts);
    }

    //ttCheckoutCustomer.push(ttCheckoutProducts);

    var onlinepayment = {};
    var invoicepayment = {};

    if (this.online_amount >= 0) {
      // if (this.online_amount >= 0 && ((this.invoice_amount+this.online_amount) != this.totalorderamt1)) {
      onlinepayment['payment_type'] = "online";
      onlinepayment['payment_amt'] = this.online_amount

      onlinepayment['cheque_num'] = this.refId+"|"+this.transId;
      ttPayment.push(onlinepayment);
    }
    // if (this.invoice_amount) {
    //if (this.invoice_amount >= 0 && this.availablecr > this.customerdetailsData.available_credit) {
    if (this.invoice_amount >= 0) {
      invoicepayment['payment_type'] = "invoice";
      invoicepayment['payment_amt'] = this.invoice_amount
      invoicepayment['cheque_num'] = "";

      ttPayment.push(invoicepayment);
    }
    checkout_data['ttPayment'] = ttPayment;

    requestBody['request'] = request;
    // LoaderComponent.loadingV.next(true);
    // console.log("requestbody" + JSON.stringify(requestBody));
    if (this.invoice_amount || this.invoice_amount >= 0 || this.online_amount || this.online_amount >= 0) {
      // console.log("entered" + this.invoice_amount, this.online_amount)
      if (this.signatureFinal && this.signatureFinal != '') {
        LoaderComponent.loadingV.next(true);
        this.IsHidden = false;
        // this.showloading = true;
        this.restApi.getcheckoutdata(requestBody)
          .subscribe(res => {
            if (res.error_message == '') {
              this.checkoutDialog = !this.checkoutDialog;
              this.checkoutdetails = res.checkout_data;
              // console.log("requestbody entered" +JSON.stringify(res));
              this.showloading = false;
              LoaderComponent.loadingV.next(false);
              this.IsHidden = true;
              this.successMessage = this.checkoutdetails["order_number"]
              this.localCart.setOrderNo(this.checkoutdetails["order_number"])

              // this.router.navigate(['/dashboard/order']);

              //alert("Your order is placed successfully.")
              // this.router.navigate(['/dashboard/order']);
              // this.orderConfirm();
            }
            else {
              this.errorDialog = !this.errorDialog
              this.errorMessage = res.error_message;
              this.IsHidden = true;
            }
          }, err => {
            let test = JSON.parse(err._body);
            LoaderComponent.loadingV.next(true);
            this.IsHidden = true;
            this.errorDialog = !this.errorDialog
            this.errorMessage = test._errors[0]._errorMsg;
            // alert(JSON.stringify(err['error_message']))
            // this.errorDialog = true;
            // this.errorData = err;
            // this.successMessage = "Sorry order could not be placed this time"
            //alert("Error in fetching the category products");
          })
      }
      else {
        this.signDialog = true;
        this.IsHidden = true;
        // alert("fbbgfbg");
      }
    }
    // else {
    //   alert(this.invalid_pymt_mthd);
    // }
    //  }
  }

  paymentdoneAndRedirectToOrders() {
    this.localCart.removeAllCartItems();
    this.router.navigate(['/dashboard/order']);
  }

  paymentdoneAndSaveToDb(e) {
    this.paymentsuccessDialog = false;
    this.proceed();
    
  }

  closeErrorModal() {
    this.errorDialog = false;
  }

  paymentres: any;
  proccedonlinepayment() {
    this.IsHidden = false;
    LoaderComponent.loadingV.next(true);
    var date = new Date();
    this.miliseconds = date.getTime();
    let shipaddress = this.selectedShippingAddress.addressL1+ this.selectedShippingAddress.addressL2;
    let billaddress = this.customerdetailsData.billing_address.billingAdd1+  this.customerdetailsData.billing_address.billingAdd2;
    let authoriseConfig =  JSON.parse(localStorage.getItem('AuthoriseConfigData'))
    const apiParams = {
      "createTransactionRequest": {
        "merchantAuthentication": {
          "name": authoriseConfig.provider_account,
          "transactionKey": authoriseConfig.provider_auth_key
        },
        "refId": this.miliseconds,
        "transactionRequest": {
          "transactionType": "authCaptureTransaction",
          "amount": this.online_amount,
          "payment": {
            "creditCard": {
              "cardNumber": this.cardnumber,
              "expirationDate":this.selectedYear+"-"+this.selectedMonth,
              "cardCode": this.cardcode
            }
          },
          // "lineItems": this.pusheditems,
          "lineItems": {
          },
          //    "lineItems": {
          //     "lineItem": {
          //       "itemId": "1",
          //       "name": "vase",
          //       "description": "Cannes logo",
          //       "quantity": "18",
          //       "unitPrice": "45.00"
          //   }
          //  },
          "tax": {
            "amount": this.taxamount(),
            "name": "level2 tax name",
            "description": "level2 tax"
          },
          "duty": {
            "amount": "8.55",
            "name": "duty name",
            "description": "duty description"
          },
          "shipping": {
            "amount": this.shippingtax(),
            "name": "level2 tax name",
            "description": "level2 tax"
          },
          "poNumber": this.poNumber,
          "customer": {
            "id": this.customerdetailsData.customer_number
          },
          "billTo": {
            //  "firstName": this.customerdetailsData.billing_address.billingAdd1,
            // "lastName": "Johnson",
            // "company": "Souveniropolis",
            "address": billaddress,
            "city": this.customerdetailsData.billing_address.city,
            "state": this.customerdetailsData.billing_address.state,
            "zip": this.customerdetailsData.billing_address.zip_code
            // "country": "USA"
          },
          "shipTo": {
            //  "firstName": this.selectedShippingAddress.addressL1,
            // "lastName": "Bayles",
            // "company": "Thyme for Tea",
            "address":shipaddress,
            "city": this.selectedShippingAddress.shippingCity,
            "state": this.selectedShippingAddress.shippingState,
            "zip": this.selectedShippingAddress.shippingZip,
            // "country": "USA"
          },
          "customerIP": this.ipaddr.ip,
          "transactionSettings": {
            "setting": {
              "settingName": "testRequest",
              "settingValue": "false"
            }
          },
          "userFields": {
            "userField": [
              {
                "name": "MerchantDefinedFieldName1",
                "value": "MerchantDefinedFieldValue1"
              },
              {
                "name": "favorite_color",
                "value": "blue"
              }
            ]
          }
        }
      }
    }
    let that = this;
    return this.http.post('https://apitest.authorize.net/xml/v1/request.api', apiParams).subscribe(res => {
      this.output = res.json();
      if (this.output) {
        // console.log("Temp : ",apiParams);
        // console.log("Temp : ",this.output);
        if (this.output.messages.resultCode == "Ok") {
          this.refId = this.miliseconds;
          that.IsHidden = true;
          this.transId = this.output.transactionResponse.transId;
          this.paymentsuccessDialog = !this.paymentsuccessDialog;
        }
        else if(this.output.transactionResponse) {
          this.ermsg = this.output.transactionResponse.errors[0].errorText;
          console.log("ghjjh" + this.ermsg);
          this.paymentfailDialog = !this.paymentfailDialog;
          that.IsHidden = true;
          return true;
        } else {
          this.ermsg = 'Payment failed!!';
          this.paymentfailDialog = !this.paymentfailDialog;
          that.IsHidden = true;
          return true;
        }

      }
    })
  }
  orderConfirm() {
    // e.preventDefault();
    // e.stopPropagation();
    this.checkoutDialog = false;

    if (this.invoice_amount == this.actual_online_amount && this.isInvoiceSelected) {
        this.IsHidden = true;
        this.paymentsuccessDialog = !this.paymentsuccessDialog;
    } else if (this.online_amount > 0) {
      // alert("Redirecting to payment gateway");
      this.proccedonlinepayment();
    }
    else {
      // alert("Redirecting to orders");
      this.localCart.removeAllCartItems();
      this.router.navigate(['/dashboard/order']);
    }
  }
  orders() {
    if (this.checkoutdetails) {
      this.successMessage = this.checkoutdetails['order_number'];
      this.router.navigate(['/dashboard/order']);
    }
    else {
      //to be done
    }
  }

  dotrestrict(event) {
    var key = event.charCode ? event.charCode : event.keyCode;
    if (key == 46) {
      event.preventDefault();
      return false;
    }
  }
  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  onBlurCreditCard(cardnumber) {
    if(cardnumber != "" && this.online_amount == this.actual_online_amount) {
      this.invoice_amount = 0;
    } else if (this.online_amount == this.actual_online_amount) {
      this.invoice_amount = Number(this.actual_online_amount);
    }
  }
  onlynumber(event) {
    var key = event.charCode ? event.charCode : event.keyCode;
    if (key >= 48 && key <= 57) {
      return true;
    }
    return false;
    //   var charCode = (evt.which) ? evt.which : event.keyCode
    // if (charCode > 31 && (charCode < 48 || charCode > 57))
    //     return false;
    // return true;
  }

  onDateChange(date: Date | null): void {
    console.log(date);
    console.log('Selected date:', date.toLocaleDateString());
    let day = date.getDate().toString().padStart(2, '0');
    let month = (date.getMonth() + 1).toString().padStart(2, '0');
    let year = date.getFullYear().toString();
    this.dateWanted = year + "-" + month + "-" + day;
    console.log(this.dateWanted);
  }

  setLabels() {
    this.langService.getLangLabelValue("LblOrderSummary").then(res => {
      this.ordersummary = res
    });
    this.langService.getLangLabelValue("LblSubTotal").then(res => {
      this.sub_toal = res
    });
    this.langService.getLangLabelValue("LblShipping_Handling").then(res => {
      this.shipping_handling = res
    });
    this.langService.getLangLabelValue("LblTax").then(res => {
      this.tax_amount = res
    });
    this.langService.getLangLabelValue("LblOrderTotal").then(res => {
      this.order_total = res
    });
    this.langService.getLangLabelValue("LblSubmitOrder").then(res => {
      this.order_submit = res
    });
    this.langService.getLangLabelValue("LblPaymentMethod").then(res => {
      this.payment_method = res
    });
    this.langService.getLangLabelValue("LblCash").then(res => {
      this.cash = res
    });
    this.langService.getLangLabelValue("LblCheck").then(res => {
      this.check = res
    });
    this.langService.getLangLabelValue("LblInvoice").then(res => {
      this.invoice_txt = res
    });
    this.langService.getLangLabelValue("LblAmount").then(res => {
      this.amount = res
    });
    this.langService.getLangLabelValue("LblAddPaymentMethod").then(res => {
      this.addpayment_method = res
    });
    this.langService.getLangLabelValue("LblReviewOrder").then(res => {
      this.order_review = res
    });
    this.langService.getLangLabelValue("LblCompleteOrder").then(res => {
      this.order_complete = res
    });
    this.langService.getLangLabelValue("LblClear").then(res => {
      this.clear = res
    });
    this.langService.getLangLabelValue("LblIAgreeToTerm&Condition").then(res => {
      this.order_terms = res
    });
    this.langService.getLangLabelValue("LblAvailableCredit").then(res => {
      this.availablecr = res
    });
    this.langService.getLangLabelValue("LblShippingInformation").then(res => {
      this.shippinginfo = res
    });
    this.langService.getLangLabelValue("LblBillingInformation").then(res => {
      this.billinginfo = res
    });
    this.langService.getLangLabelValue("LblCreditLimit").then(res => {
      this.credit_limit = res
    });
    this.langService.getLangLabelValue("LblQuantity").then(result => {
      this.quantity = result;
    });

    this.langService.getLangLabelValue("LblItem").then(result => {
      this.item_number = result;
    });
    this.langService.getLangLabelValue("Lblitems").then(result => {
      this.items = result;
    });
    this.langService.getLangLabelValue("LblPrimary").then(res => {
      this.primary = res
    });

    this.langService.getLangLabelValue("LblCheckout").then(res => {
      this.checkout = res
    });
    this.langService.getLangLabelValue("LblAddYourSignature").then(res => {
      this.addsignature = res
    });
    this.langService.getLangLabelValue("LblCityTax").then(res => {
      this.city_tax = res
    });
    this.langService.getLangLabelValue("LblStateTax").then(res => {
      this.state_tax = res
    });
    this.langService.getLangLabelValue("LblValidName").then(res => {
      this.valid_name = res
    });
    this.langService.getLangLabelValue("200_signee_name_blank").then(res => {
      this.signee_name = res
    });
    this.langService.getLangLabelValue("LblEnteredAmtCantBeLesser").then(res => {
      this.amount_check = res
    });
    this.langService.getLangLabelValue("LblPORequired").then(res => {
      this.po_required = res
    });
    this.langService.getLangLabelValue("LblItemDoesNotExist").then(res => {
      this.item_not_exist = res
    });
    this.langService.getLangLabelValue("LblEnteredAmtCantBeMoreThan").then(res => {
      this.amount_check_more = res
    });
    this.langService.getLangLabelValue("200_invalid_payment_method").then(res => {
      this.invalid_pymt_mthd = res
    });
    this.langService.getLangLabelValue("LblAddYourSignature").then(res => {
      this.add_sign = res

    });
    this.langService.getLangLabelValue("LblOnline").then(res => {
      this.online_txt = res
    });
    this.langService.getLangLabelValue("LblAddPaymentMethod").then(res => {
      this.add_payment = res
    });
    this.langService.getLangLabelValue("LblPONumber").then(res => {
      this.po_number = res
    });
    this.langService.getLangLabelValue("LblName").then(res => {
      this.name_text = res
    });
    this.langService.getLangLabelValue("200_order_placed_online").then(res => {
      this.order_msg1 = res
    });
    this.langService.getLangLabelValue("200_order_number").then(res => {
      this.order_msg2 = res
    });
    this.langService.getLangLabelValue("Lblok").then(res => {
      this.lbl_ok = res
    });
    this.langService.getLangLabelValue("LblItemUOM").then(result => {
      this.lbl_uom = result;
    });
    this.langService.getLangLabelValue("LblUOMQty").then(result => {
      this.lbl_qty = result;
    });
    this.langService.getLangLabelValue("LblYes").then(result => {
      this.lbl_yes = result;
    });
    this.langService.getLangLabelValue("LblNo").then(result => {
      this.lbl_no = result;
    });
    this.langService.getLangLabelValue("200_insufficientCredLim").then(result => {
      this.lbl_insuff = result;
    });
    this.langService.getLangLabelValue("200_online_amount_exceed").then(result => {
      this.lbl_onlineexceed = result;
    });
    this.langService.getLangLabelValue("LblTotalAmtLess").then(result => {
      this.lbl_less = result;
    });
    this.langService.getLangLabelValue("LblRemainingAmt").then(result => {
      this.lbl_remain = result;
    });
    this.langService.getLangLabelValue("LblPDFNotAvailable").then(result => {
      this.pdfnot_avail = result;

    });
    this.langService.getLangLabelValue("LblSelected").then(res => {
      this.lbl_selected = res
    });
    this.langService.getLangLabelValue("LblNoItem").then(res => {
      this.lbl_noitem = res
    });
    this.langService.getLangLabelValue("LblOpenPDF").then(res => {
      this.lbl_openpdf = res
    });

    this.langService.getLangLabelValue("200_less_pay_amount").then(res => {
      this.lbl_lesspay = res
    });
    this.langService.getLangLabelValue("200_enter_card_no").then(res => {
      this.lbl_cardnumber = res
      console.log("aaaaa"+this.lbl_cardnumber)
    });
    this.langService.getLangLabelValue("200_enter_month").then(res => {
      this.lbl_month = res
    });
    this.langService.getLangLabelValue("200_enter_year").then(res => {
      this.lbl_year = res
    });
    this.langService.getLangLabelValue("200_enter_cardcode").then(res => {
      this.lbl_cardcode = res
    });
    this.langService.getLangLabelValue("LblCardNumber").then(res => {
      this.txt_cardnumber = res
      console.log("crdtext"+this.txt_cardnumber)
    });
    this.langService.getLangLabelValue("LblExpirydate").then(res => {
      this.txt_expirydate = res
      console.log("crdtext"+this.txt_expirydate)
      
    });
    this.langService.getLangLabelValue("LblCardcode").then(res => {
      this.txt_cardcode = res
    });
  }
  close() {
    this.location.back();
  }

  getSubTotalItemPrice(item){
    let subTotalItemPrice = item.quantity * item.unit_price;
    let discount = this.calculateItemDiscount(item);
    return subTotalItemPrice - discount;
  } 

  calculateItemDiscount(item){
    let up_to_qty1 = item.up_to_qty1;
      let up_to_qty2 = item.up_to_qty2;
      let up_to_qty3 = item.up_to_qty3;
      let up_to_qty4 = item.up_to_qty4;
      let up_to_qty5 = item.up_to_qty5;
    
      let up_to_price1 = item.up_to_price1;
      let up_to_price2 = item.up_to_price2;
      let up_to_price3 = item.up_to_price3;
      let up_to_price4 = item.up_to_price4;
      let up_to_price5 = item.up_to_price5;
    
      let item_percent_for_disc = item.item_percent_for_disc;

      let subTotalPrice = item.quantity * item.unit_price;

      if (up_to_qty1 > 0 || up_to_qty2 > 0 || up_to_qty3 > 0 || up_to_qty4 > 0 || up_to_qty5 > 0) {
        if (item.quantity >= up_to_qty1 && item.quantity < up_to_qty2) {
            return subTotalPrice * up_to_price1 / 100.0; 
        } else if (item.quantity >= up_to_qty2 && item.quantity < up_to_qty3) {
            return subTotalPrice * up_to_price2 / 100.0; 
        } else if (item.quantity >= up_to_qty3 && item.quantity < up_to_qty4) {
            return subTotalPrice * up_to_price3 / 100.0; 
        } else if (item.quantity >= up_to_qty4 && item.quantity < up_to_qty5) {
            return subTotalPrice * up_to_price4 / 100.0; 
        } else if (item.quantity >= up_to_qty5) {
            return subTotalPrice * up_to_price5 / 100.0;  
        } else {
          return 0;
        }
      }
      else {
        return 0;
      }
  }

  getItemDiscountedPrice(item){
    let up_to_qty1 = item.up_to_qty1;
    let up_to_qty2 = item.up_to_qty2;
    let up_to_qty3 = item.up_to_qty3;
    let up_to_qty4 = item.up_to_qty4;
    let up_to_qty5 = item.up_to_qty5;
  
    let up_to_price1 = item.up_to_price1;
    let up_to_price2 = item.up_to_price2;
    let up_to_price3 = item.up_to_price3;
    let up_to_price4 = item.up_to_price4;
    let up_to_price5 = item.up_to_price5;

    if (up_to_qty1 > 0 || up_to_qty2 > 0 || up_to_qty3 > 0 || up_to_qty4 > 0 || up_to_qty5 > 0) {
      if (item.quantity >= up_to_qty1 && item.quantity < up_to_qty2) {
        return item.unit_price * up_to_price1 / 100.0; 
    } else if (item.quantity >= up_to_qty2 && item.quantity < up_to_qty3) {
        return item.unit_price * up_to_price2 / 100.0; 
    } else if (item.quantity >= up_to_qty3 && item.quantity < up_to_qty4) {
        return item.unit_price * up_to_price3 / 100.0; 
    } else if (item.quantity >= up_to_qty4 && item.quantity < up_to_qty5) {
        return item.unit_price * up_to_price4 / 100.0; 
    } else if (item.quantity >= up_to_qty5) {
        return item.unit_price * up_to_price5 / 100.0;  
    } else {
      return 0;
    }
    }
    else {
      return 0;
    }  
  }

  getTotalCartAmount() {
    if (this.cartItems) {
      let totalcartamount = this.cartItems;
      const bArray = totalcartamount.map(item => this.getSubTotalItemPrice(item));
      const res = bArray.reduce(function (a, b) { return a + b; }, 0);
      const result = Math.round(res * 100) / 100;
      return result;
    }
  }

  calculateFreeBoxes(item){
    let freeBoxes = 0;
    let buy_qty_to_get_free = item.buy_qty_to_get_free;
    let get_free_item = item.get_free_item;

    if (item.quantity >= buy_qty_to_get_free) {
      freeBoxes = get_free_item * ~~(Number(item.quantity) / buy_qty_to_get_free);
    }
    return freeBoxes;
  }

  getTotalQuantity() {
    if (this.cartItems) {
      let totalcartamount = this.cartItems;
      const bArray = totalcartamount.map(item => item.quantity + this.calculateFreeBoxes(item));
      const result = bArray.reduce(function (a, b) { return a + b; }, 0);
      return result;
    }
  }

  // onClearHandler() {
  // }

  // onSaveHandler(data) {
  //   window.open(data);
  // }
  ordertotal() {
    for (let item of this.cartItems) {

      // this.totalorderamt = Math.round((this.getTotalCartAmount() +this.taxamount()+this.shippingtax()* 100) / 100);
      this.totalorderamt1 = this.getTotalCartAmount() + this.citytaxamount() + this.statetaxamount() + this.shippingtax();
      this.totalorderamt = Math.round(this.totalorderamt1 * 100) / 100;
      // console.log("totalamt"+ this.totalorderamt);
    }

    this.online_amount = this.totalorderamt;
    this.actual_online_amount = this.totalorderamt;
    this.invoice_amount = this.totalorderamt;
    this.totalorderamt1 = this.totalorderamt;
    // this.invoicevalue =  Math.round(this.totalorderamt - this.online_amount * 100) / 100;

    // this.getInvoiceValue();
    // return Number.parseInt(""+this.totalorderamt).toFixed(2);
    return this.totalorderamt;
    //return this.totalorderamt;
  }

  // getInvoiceValue() {
  //   this.invoice_amount = this.totalorderamt1 - this.online_payment;
  //   // this.invoice_amount = this.totalorderamt1 - this.online_payment;
  //   // return this.invoice_amount;
  //   //return Number.parseInt(""+this.invoice_amount).toFixed(2);

  //   return Math.round(this.invoice_amount * 100) / 100
  // }

  setSelectedShipNumber(selected_ship_num: string) {
    this.selected_ship_num = selected_ship_num;
  }

  shippingtax() {

    return this.shippingTax;
  }

  calculateShippingTax() {
    this.shippingTax = 0;
    if (this.cartItems && this.cartItems != undefined) {
      for (let item of this.cartItems) {
        if (item && item.product_info && item.product_info.item_tax_unit) {
          for (let itemUnit of item.product_info.item_tax_unit) {
            let shipping = itemUnit.freight_unit;
            if (itemUnit.ship_number == this.selected_ship_num) {
              shipping *= item.quantity;
              this.shippingTax += shipping;
            }
          }

        }


        this.langService.getCurrentCompany().subscribe(company => {


          if (company['companyFreight'] < this.shippingTax) {
            this.shippingTax = company['companyFreight'];

          }
          this.ordertotal()
        });
      };
    }
  }

  taxamount() {
    let totalTax = 0;
    if (this.cartItems && this.cartItems != undefined) {
      for (let item of this.cartItems) {
        if (item && item.product_info && item.product_info.item_tax_unit) {
          for (let itemUnit of item.product_info.item_tax_unit) {

            let tax = itemUnit.city_tax_unit + itemUnit.state_tax_unit;

            if (itemUnit.ship_number == this.selected_ship_num) {
              tax *= item.quantity;
              totalTax += tax;
            }

          }
        }
      }
    }

    return totalTax.toFixed(2);
  }
  citytaxamount() {
    let citytax = 0;
    if (this.cartItems && this.cartItems != undefined) {
      for (let item of this.cartItems) {
        if (item && item.product_info && item.product_info.item_tax_unit) {
          for (let itemUnit of item.product_info.item_tax_unit) {

            let tax = itemUnit.city_tax_unit;

            if (itemUnit.ship_number == this.selected_ship_num) {
              tax *= item.quantity;
              citytax += tax;
              //console.log("citytax"+citytax);
              citytax = Math.round((citytax) * 100) / 100;
              // console.log("citytax1"+citytax);
            }

          }
        }
      }
    }

    return citytax;
  }
  statetaxamount() {
    let stateTax = 0;
    if (this.cartItems && this.cartItems != undefined) {
      for (let item of this.cartItems) {
        if (item && item.product_info && item.product_info.item_tax_unit) {
          for (let itemUnit of item.product_info.item_tax_unit) {

            let tax = itemUnit.state_tax_unit;

            if (itemUnit.ship_number == this.selected_ship_num) {
             // tax *= item.quantity;
              // stateTax += tax;
              // stateTax = Math.round((stateTax) * 100) / 100;
              let stateTaxCal = (item.unit_price * itemUnit.state_tax_unit) / 100;
                stateTax += +(stateTaxCal * item.quantity);
            }

          }
        }
      }
    }

    return stateTax;
  }
  setPrimaryAddress(selectedShippingAddress) {
    this.selectedShippingAddress = selectedShippingAddress;
    console.log("zsdfdf" + JSON.stringify(this.selectedShippingAddress))
  }
  // check1(val) {

  //   //  this.el.nativeElement.onkeypress = (event) => {
  //   if (val.keyCode >= 48 && val.keyCode <= 57) {
  //     // to allow numbers  
  //     return true;
  //   } else if (val.charCode >= 96 && val.charCode <= 105) {
  //     // to allow numpad number  
  //     return true;
  //   }
  //   // else if ([8, 127].indexOf(val.charCode) > -1) {
  //   //   // to allow backspace, enter, escape, arrows  
  //   //   return true;
  //   // }

  //   else {
  //     let res = false;
  //     if (val.keyCode == 190 && this.dotCount) {
  //       this.dotCount = false
  //       res = true;
  //     }

  //     else if (val.keyCode == 8 && this.online_amount.toString().indexOf('.') == -1) {
  //       this.dotCount = true
  //       res = true
  //     }
  //     else if (val.keyCode == 8) {
  //       res = true
  //       return res

  //     }


  //     //   if(val != null){
  //     //   if(this.online_amount.toString()!=null)
  //     //   {
  //     //   let x = val['key'] 

  //     //   // if (x == '.' && this.dotCount){
  //     //   //   this.dotCount=false
  //     //   //   return true
  //     //   // }
  //     //   // else if(!(this.online_amount.toString().indexOf('.')!=-1)  )
  //     //   //  this.dotCount=true

  //     //    if ((x >= 0 && x <= 9) || x == 'Backspace')
  //     //     return true
  //     //   else
  //     //     return false
  //     //   }
  //     // }
  //     // }
  //   }

  //   // onSearchChange(event) {  
  //   //   if (event.which >= 97 && event.which <= 122) {  
  //   //     // to allow alphabets  
  //   //     return true;  
  //   //   }
  //   //   else {  
  //   //     event.preventDefault();  
  //   //     // to stop others  
  //   //     return false;  
  //   // }  


  //   // }
  // }
  onlyDecimalNumberKey(event) {
    //this.valid_amount = false;
    let charCode = (event.which) ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
    return true;
  }

  itemSelected(item) {
    this.localStorage.setItem('productSelected', item).subscribe(res => {
      this.router.navigate(['/cartdetails']);
    });
  }
  getItemUOM(item) {
    if (this.isRepeatOrder) {
      return item.item_uom
    }
    return item.product_info.item_uom
  }

  getItemUOMQty(item) {
    if (this.isRepeatOrder) {
      return item.uom_qty
    }
    return item.product_info.uom_qty
  }

  ConvertToInt(val) {
    return parseInt(val);
  }
  getdatamessage() {
    if ((this.online_amount + this.invoice_amount) < this.totalorderamt1) {
      this.displaymessage = true;
    }
    else {
      this.displaymessage = false;
    }
  }
  getreaminamount() {
    this.remainamt = this.totalorderamt1 - this.online_amount
    this.remainamt = Math.round((this.remainamt) * 100) / 100;
    // let num = parseInt(this.remainamt) || 0;
    if (this.online_amount == "." || this.online_amount.length == 0) {
      return this.totalorderamt1;
    }
    if (this.remainamt < 0) {
      return 0;
    }
    else {
      return this.remainamt;
    }

  }
  noPdf() {
    this.noPdfavl = true;
    setTimeout(function () {
      this.noPdfavl = false;
    }.bind(this), 5000);
  }
  monthChanged(selectedmonth) {
    this.selectedMonth = selectedmonth;
  }
  yearChanged(selectedyear) {
    this.selectedYear = selectedyear;
  }

  invoiceSelected(event) {
    this.isInvoiceSelected = true;
    // if(this.cardnumber != undefined && this.online_amount == this.actual_online_amount) {
    //   this.invoice_amount = 0;
    // } else if(this.online_amount == this.actual_online_amount) {
    //   this.invoice_amount = this.actual_online_amount;
    // }
  }

  onlineSelected(event) {
    let paymentMethodSetup = localStorage.getItem('PaymentMethodSetup');

    if(paymentMethodSetup == "no") {
      alert("This facility is not available yet!");
      setTimeout(() => {
        document.getElementById("offlineMode").click();
        document.getElementById("online").classList.remove("active");

      }, 100);

      setTimeout(() => {
        document.getElementById("online").classList.remove("active");
      }, 200);
      
      this.isInvoiceSelected = true;
    } else {
      this.isInvoiceSelected = false;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/checkout/checkout.component.ts